import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=3a9589b1&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=3a9589b1&prod&lang=scss&scoped=true"
import style1 from "./Item.vue?vue&type=style&index=1&id=3a9589b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9589b1",
  null
  
)

export default component.exports